import { render, staticRenderFns } from "./ObjectStoreBadge.vue?vue&type=template&id=48d2e54e&scoped=true"
import script from "./ObjectStoreBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ObjectStoreBadge.vue?vue&type=style&index=0&id=48d2e54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2e54e",
  null
  
)

export default component.exports